module.exports = __webpack_public_path__ + "static/media/box-delivery.775fa2d7.png";